var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ngid-base-layout',{staticClass:"profile-page",attrs:{"fluid":""}},[_vm._t("default"),_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"8"}},[_c('profile-management')],1)],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }